import { Brand } from '@retail/auth/types';
import {
  CampaignBrandsField,
  CampaignDateFields,
  CampaignDescriptionField,
  CampaignMandatoryField,
  CampaignNameField,
  CampaignTypeField,
} from './CreateCampaignFields';

interface Props {
  availableBrands: Brand[];
}

export const CreateBrandCampaignForm = ({ availableBrands }: Props) => {
  return (
    <>
      <CampaignNameField />
      <CampaignMandatoryField />
      <CampaignTypeField />
      <CampaignDescriptionField />
      <CampaignBrandsField availableBrands={availableBrands} />
      <CampaignDateFields />
    </>
  );
};
